var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var Renderer = /** @class */ (function () {
    function Renderer() {
        this.width = 0;
        this.height = 0;
        this.pixelRatio = 1;
        this.background = 'transparent';
        this.focusedNodeId = null;
        this.highContrast = false;
        this.dirtyRegions = [];
        this.fullRedraw = true;
        this.hasRendered = false;
    }
    Renderer.prototype.markDirty = function (x, y, w, h) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        this.dirtyRegions.push({
            x: x,
            y: y,
            width: w !== null && w !== void 0 ? w : this.width,
            height: h !== null && h !== void 0 ? h : this.height,
        });
        this.fullRedraw = this.dirtyRegions.length > 10;
    };
    Renderer.prototype.clearDirty = function () {
        this.dirtyRegions = [];
        this.fullRedraw = false;
        this.hasRendered = true;
    };
    Renderer.prototype.forceFullRedraw = function () {
        this.fullRedraw = true;
        this.dirtyRegions = [];
    };
    Renderer.prototype.setRenderState = function (state) {
        if (state.focusedNodeId !== undefined)
            this.focusedNodeId = state.focusedNodeId;
        if (state.highContrast !== undefined)
            this.highContrast = state.highContrast;
    };
    Object.defineProperty(Renderer.prototype, "needsFullRedraw", {
        get: function () {
            return this.fullRedraw || !this.hasRendered;
        },
        enumerable: false,
        configurable: true
    });
    Renderer.prototype.applyFillStyle = function (_ctx, fill, setFill) {
        if (!fill)
            return;
        if (typeof fill === 'string') {
            setFill(fill);
        }
        else if (fill.type === 'linear' || fill.type === 'radial') {
            var g = fill;
            /* Gradient applied by concrete renderers */
            void g;
        }
    };
    Renderer.prototype.applyStrokeStyle = function (_ctx, stroke, setStroke) {
        if (!stroke)
            return;
        if (typeof stroke === 'string') {
            setStroke(stroke);
        }
    };
    Renderer.prototype.applyShadow = function (ctx, shadow) {
        if (shadow) {
            ctx.shadowColor = shadow.color;
            ctx.shadowBlur = shadow.blur;
            ctx.shadowOffsetX = shadow.offsetX;
            ctx.shadowOffsetY = shadow.offsetY;
        }
        else {
            ctx.shadowColor = 'transparent';
            ctx.shadowBlur = 0;
        }
    };
    /** Traverse and draw scene graph */
    Renderer.prototype.traverse = function (node, drawFn) {
        var e_1, _a;
        var _b;
        if (!node.visible)
            return;
        drawFn(node);
        if ('children' in node) {
            var group = node;
            (_b = group.sortChildren) === null || _b === void 0 ? void 0 : _b.call(group);
            try {
                for (var _c = __values(group.children), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var child = _d.value;
                    this.traverse(child, drawFn);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    return Renderer;
}());
export { Renderer };
